export default __webpack_public_path__ + "static/media/sounds/daze_direction_alyx.mp3";